define('lq/cache',[
    'underscore'
], function (_) {
	'use strict';

	var Cache = function () {
		this.store = {};
	};

	Cache.prototype.hasOwn = function (property) {
	    return Object.prototype.hasOwnProperty.call(this.store, property);
	};

	Cache.prototype.set = function (key, value) {
	    this.store[key] = value;
	};

	Cache.prototype.get = function (key) {
	    if (this.has(key))
	        return this.store[key];
	    return undefined;
	};

	Cache.prototype.has = function (key) {
	    return this.hasOwn(key);
	};

	Cache.prototype.remove = function (key) {
	    delete this.store[key];
	};

	Cache.prototype.clear = function () {
	    this.store = {};
	};

	Cache.prototype.keys = function () {
	    return _.keys(this.store);
	};

	Cache.prototype.values = function () {
	    return _.values(this.store);
	};

	return Cache;
});
